import { appActionTypes } from "../constants/appActionTypes";
import { TRANSCRIPT_STATUS } from "../constants/appPayloadTypes";
import { authActionTypes } from "../constants/authActionTypes";
const initialState = {
  transcript_data: null,
  transcript_status: TRANSCRIPT_STATUS.NOT_ADDED,
  calendarIntegrationPopup: false,

  // New state for app settings
  appSettings: {
    payment: {
      language: "",
      subscription: "",
    },
    feature: "",
    timeLimit: 0,
  },
};
export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.SET_TRANSCRIPT_DATA:
      return { ...state, transcript_data: action.payload };
    case appActionTypes.SET_TRANSCRIPT_STATUS:
      return { ...state, transcript_status: action.payload };
    case appActionTypes.INTEGRATE_CALENDAR_POPUP:
      return { ...state, calendarIntegrationPopup: action.payload };
    case appActionTypes.SET_APP_SETTINGS:
      return { ...state, appSettings: action.payload };
    case authActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
};
